import { Stagger, StaggerItem } from "@/components/motion/Reveal";
import { STATS } from "@/data/content";

export const StatsBand = () => (
  <section className="py-16 lg:py-20 bg-brand-bg border-y border-brand-line" data-testid="stats-band">
    <div className="container-x">
      <Stagger className="grid grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-6" gap={0.1}>
        {STATS.map((s, i) => (
          <StaggerItem key={i} className="text-center lg:text-left">
            <p className="font-display font-black text-4xl sm:text-5xl text-brand-navy leading-none">
              {s.value}
            </p>
            <span className="mt-3 block h-1 w-10 bg-brand-red rounded-full mx-auto lg:mx-0" />
            <p className="mt-3 text-brand-ink2 font-semibold">{s.label}</p>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);
